import { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import { ChevronUp } from "lucide-react";

const SCROLL_THRESHOLD = 300;

export default function BackToTop() {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(false);

  const isMenoPage = useMemo(() => {
    const path = router.asPath || "";
    return /\/meno-digital-menu(?:[/?#]|$)/.test(path);
  }, [router.asPath]);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_THRESHOLD);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // initial check
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      className={`back-to-top${isMenoPage ? " back-to-top--meno" : ""}`}
    >
      <ChevronUp className="back-to-top__icon" aria-hidden />
    </button>
  );
}
